import { Component, OnInit, computed, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextarea } from 'primeng/inputtextarea';
import { DialogModule } from 'primeng/dialog';
import { DatePickerModule } from 'primeng/datepicker';
import { PaginatorModule, PaginatorState } from 'primeng/paginator';
import { TooltipModule } from 'primeng/tooltip';
import { ToastModule } from 'primeng/toast';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MessageService } from 'primeng/api';
import {
  InformacionEmpresaEjecDetalle,
  InformacionEmpresaEjecDetalleFiltro
} from 'src/app/domain/model/informacion-empresa/informacion-empresa-oc';
import { InformacionEmpresaRepository } from 'src/app/domain/service/informacion-empresa/informacion-empresa-repository';
import { OficinaRepository } from 'src/app/domain/service/oficina/oficina-repository';
import { DocumentoP8Service } from 'src/app/domain/service/documento-p8/documento-p8.service';
import { UsuarioStateService } from 'src/app/infrastructure/state/usuario-state.service';
import {
  AsesorSeleccionado,
  BusquedaAsesorDialogComponent as AsesorSearchComponent
} from '../common/busquedas/busqueda-asesor-dialog.component';
import {
  BusquedaCentroTrabajoDialogComponent,
  CentroTrabajoSeleccionado
} from '../common/busquedas/busqueda-centro-trabajo-dialog.component';
import {
  BusquedaClasificacionDialogComponent,
  ClasificacionSeleccionada
} from '../common/busquedas/busqueda-clasificacion-dialog.component';
import {
  BusquedaTareaDialogComponent,
  TareaSeleccionada
} from '../common/busquedas/busqueda-tarea-dialog.component';

interface OpcionOficina {
  label: string;
  value: number;
}

interface OpcionCatalogo {
  label: string;
  value: number | null;
}

@Component({
  selector: 'app-informacion-empresa-detalle-servicios-entregados',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RouterLink,
    ButtonModule,
    TableModule,
    InputTextModule,
    InputTextarea,
    DropdownModule,
    DialogModule,
    DatePickerModule,
    PaginatorModule,
    TooltipModule,
    ToastModule,
    ProgressSpinnerModule,
    BusquedaTareaDialogComponent,
    BusquedaClasificacionDialogComponent,
    BusquedaCentroTrabajoDialogComponent,
    AsesorSearchComponent
  ],
  providers: [MessageService],
  styleUrls: ['../shared/styles/grid-table.styles.scss'],
  template: `
    <div class="p-3 sm:p-6 max-w-7xl mx-auto">
      <p-toast position="top-right"></p-toast>

      @if (descargandoDocumento()) {
        <div class="fixed inset-0 bg-black/50 z-[9999] flex items-center justify-center">
          <div class="bg-white rounded-lg p-6 shadow-xl flex flex-col items-center gap-4">
            <p-progressSpinner
              styleClass="w-16 h-16"
              strokeWidth="4"
              animationDuration=".8s">
            </p-progressSpinner>
            <span class="text-lg font-medium text-gray-700">{{ mensajeDescarga() }}</span>
            <span class="text-sm text-gray-500">Por favor espere</span>
          </div>
        </div>
      }

      <div class="mb-4 flex items-center justify-between gap-2 flex-wrap">
        <div>
          <span class="text-sm text-gray-600 mb-2 flex items-center gap-2"
            >Información Empresa >> Servicios Entregados >><b> Detalle</b>
          </span
          >
          <h1 class="text-xl sm:text-2xl font-bold text-gray-800 dark:text-gray-100">
            Detalle Servicios Entregados
          </h1>
          <p class="text-sm text-gray-600 dark:text-gray-400">
            Consulta detallada de servicios ejecutados por producto.
          </p>
        </div>

        <div class="flex flex-wrap items-center gap-2">
          <a [routerLink]="'/informacion-empresa'" [queryParams]="queryParamsPrincipal()">
            <button
              pButton
              label="Información Empresa"
              icon="pi pi-home"
              severity="secondary"
              class="p-button-outlined"
            ></button>
          </a>

          <a
            [routerLink]="'/informacion-empresa/servicios-entregados'"
            [queryParams]="queryParamsRegreso()"
          >
            <button
              pButton
              label="Regresar"
              icon="pi pi-arrow-left"
              severity="secondary"
              class="p-button-outlined"
            ></button>
          </a>
        </div>
      </div>

      <div class="rounded-lg border border-orange-200 bg-orange-100 p-4 text-orange-900 mb-4">
        <div class="font-semibold mb-2">Contexto de consulta</div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-2 text-sm">
          <div class="rounded px-3 py-2 border border-orange-100">
            <span class="font-medium">Cliente:</span>
            <span class="ml-2">{{ nombreCliente() }}</span>
          </div>
          <div class="rounded px-3 py-2 border border-orange-100">
            <span class="font-medium">Producto:</span>
            <span class="ml-2">{{ productoContexto() }}</span>
          </div>
        </div>
      </div>

      <div class="border border-gray-200 dark:border-gray-700 rounded p-4 mb-4 bg-gray-50 dark:bg-gray-800">
        <div class="font-medium text-gray-700 dark:text-gray-200 mb-3 text-sm">Filtros</div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
          <div>
            <label class="block text-sm text-gray-600 dark:text-gray-300 mb-1">Tarea</label>
            <div class="flex items-center gap-2 min-w-0 ">
              <input pInputText [value]="tareaSeleccionadaLabel()" class="flex-1 min-w-0" readonly />
              <button pButton icon="pi pi-search" class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]" pTooltip="Buscar tarea"
                (click)="mostrarBuscadorTarea = true"></button>
              @if (tareaSeleccionada()) {
                <button type="button" pButton icon="pi pi-times" class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
                  severity="danger" pTooltip="Limpiar tarea" (click)="limpiarTarea()"></button>
              }
            </div>
          </div>

          <div>
            <label class="block text-sm text-gray-600 dark:text-gray-300 mb-1">Clasificación</label>
            <div class="flex items-center gap-2 min-w-0 ">
              <input pInputText [value]="clasificacionSeleccionadaLabel()" class="flex-1 min-w-0" readonly />
              <button pButton icon="pi pi-search" class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]" pTooltip="Buscar clasificación"
                (click)="mostrarBuscadorClasificacion = true"></button>
              @if (clasificacionSeleccionada()) {
                <button type="button" pButton icon="pi pi-times" class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
                  severity="danger" pTooltip="Limpiar clasificación" (click)="limpiarClasificacion()"></button>
              }
            </div>
          </div>

          <div>
            <label class="block text-sm text-gray-600 dark:text-gray-300 mb-1">Tipo de Cita</label>
            <p-dropdown
              [options]="tiposCita()"
              optionLabel="label"
              optionValue="value"
              [(ngModel)]="filtroTipoCita"
              [filter]="true"
              [showClear]="true"
              placeholder="Seleccione tipo cita"
              [style]="{ width: '100%' }"
              appendTo="body">
            </p-dropdown>
          </div>

          <div>
            <label class="block text-sm text-gray-600 dark:text-gray-300 mb-1">Estado de Cita</label>
            <p-dropdown
              [options]="estadosCita()"
              optionLabel="label"
              optionValue="value"
              [(ngModel)]="filtroEstadoCita"
              [filter]="true"
              [showClear]="false"
              placeholder="Seleccione estado"
              [style]="{ width: '100%' }"
              appendTo="body">
            </p-dropdown>
          </div>

          <div>
            <label class="block text-sm text-gray-600 dark:text-gray-300 mb-1">Cumplimiento</label>
            <input
              pInputText
              [(ngModel)]="filtroCumplimiento"
              maxlength="11"
              class="w-full"
              placeholder="Ingrese cumplimiento"
              (input)="onCumplimientoInput($event)"
            />
          </div>

          <div>
            <label class="block text-sm text-gray-600 dark:text-gray-300 mb-1">Consultor</label>
            <div class="flex items-center gap-2 min-w-0 ">
              <input pInputText [value]="consultorSeleccionadoLabel()" class="flex-1 min-w-0" readonly />
              <button pButton icon="pi pi-search" class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]" pTooltip="Buscar consultor"
                (click)="mostrarBuscadorConsultor = true"></button>
              @if (consultorSeleccionado()) {
                <button type="button" pButton icon="pi pi-times" class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
                  severity="danger" pTooltip="Limpiar consultor" (click)="limpiarConsultor()"></button>
              }
            </div>
          </div>

          <div>
            <label class="block text-sm text-gray-600 dark:text-gray-300 mb-1">
              Oficina <span class="text-red-500">*</span>
            </label>
            <p-dropdown
              [options]="oficinas()"
              optionLabel="label"
              optionValue="value"
              [(ngModel)]="filtroOficina"
              [filter]="true"
              [showClear]="false"
              [style]="{ width: '100%' }"
              appendTo="body">
            </p-dropdown>
          </div>

          <div class="md:col-span-2">
            <label class="block text-sm text-gray-600 dark:text-gray-300 mb-1">Centro de Trabajo</label>
            <div class="flex items-center gap-2 min-w-0 ">
              <input pInputText [value]="centroTrabajoSeleccionadoLabel()" class="flex-1 min-w-0" readonly />
              <button pButton icon="pi pi-search" class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]" pTooltip="Buscar centro de trabajo"
                (click)="abrirBusquedaCentroTrabajo()"></button>
              @if (centroTrabajoSeleccionado()) {
                <button type="button" pButton icon="pi pi-times" class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
                  severity="danger" pTooltip="Limpiar centro de trabajo" (click)="limpiarCentroTrabajo()"></button>
              }
            </div>
          </div>

          <div>
            <label class="block text-sm text-gray-600 dark:text-gray-300 mb-1">
              Fecha Inicial Programación <span class="text-red-500">*</span>
            </label>
            <p-datepicker
              [(ngModel)]="fechaInicial"
              dateFormat="yy/mm/dd"
              [showIcon]="true"
              [style]="{ width: '100%' }"
              appendTo="body">
            </p-datepicker>
          </div>

          <div>
            <label class="block text-sm text-gray-600 dark:text-gray-300 mb-1">
              Fecha Final Programación <span class="text-red-500">*</span>
            </label>
            <p-datepicker
              [(ngModel)]="fechaFinal"
              dateFormat="yy/mm/dd"
              [showIcon]="true"
              [style]="{ width: '100%' }"
              appendTo="body">
            </p-datepicker>
          </div>
        </div>

        <div class="mt-4 flex flex-wrap justify-end sm:justify-start gap-3 w-full">
          <button pButton label="Limpiar" icon="pi pi-eraser" class="p-button-outlined" severity="secondary" (click)="limpiarFiltros()"></button>
          <button pButton label="Buscar" icon="pi pi-search" (click)="buscar()"></button>
        </div>
      </div>

      @if (mensaje()) {
        <div class="p-3 mt-4 rounded" [ngClass]="mensajeClass()">
          {{ mensaje() }}
        </div>
      }

      <div class="mt-4">
        <div class="md:hidden space-y-3">
          @if (!loading() && items().length === 0) {
            <div class="text-center p-4 text-gray-500 border border-gray-200 dark:border-gray-700 rounded-lg">
              No se encontraron resultados para los filtros enviados.
            </div>
          }

          @for (item of items(); track $index) {
            <div class="border border-gray-200 dark:border-gray-700 rounded-lg p-3 bg-white dark:bg-gray-900">
              <div class="grid grid-cols-1 gap-2 text-sm">
                <div><span class="text-gray-500">Orientación:</span> <span class="text-gray-800 dark:text-gray-200">{{ item.dsorden || '-' }}</span></div>
                <div><span class="text-gray-500">Tarea:</span> <span class="text-gray-800 dark:text-gray-200">{{ item.dstarea || '-' }}</span></div>
                <div><span class="text-gray-500">Clasificación:</span> <span class="text-gray-800 dark:text-gray-200">{{ item.dsclasificacion || '-' }}</span></div>
                <div><span class="text-gray-500">Tipo de Cita:</span> <span class="text-gray-800 dark:text-gray-200">{{ item.dstipocita || '-' }}</span></div>
                <div><span class="text-gray-500">Horas Ejecutadas:</span> <span class="text-gray-800 dark:text-gray-200">{{ item.nmcantidadEjecutada ?? '-' }}</span></div>
                <div><span class="text-gray-500">Asesor:</span> <span class="text-gray-800 dark:text-gray-200">{{ item.dsasesor || '-' }}</span></div>
                <div><span class="text-gray-500">Tipo Asesor:</span> <span class="text-gray-800 dark:text-gray-200">{{ item.dstipo || '-' }}</span></div>
                <div><span class="text-gray-500">Oficina:</span> <span class="text-gray-800 dark:text-gray-200">{{ item.dsoficina || '-' }}</span></div>
                <div><span class="text-gray-500">Empresa:</span> <span class="text-gray-800 dark:text-gray-200">{{ item.nomempresa || '-' }}</span></div>
                <div><span class="text-gray-500">Centro Trabajo:</span> <span class="text-gray-800 dark:text-gray-200">{{ item.dscentrot || '-' }}</span></div>
                <div><span class="text-gray-500">Fecha y Hora Cita:</span> <span class="text-gray-800 dark:text-gray-200">{{ item.feprogramacion || '-' }}</span></div>
              </div>
              <div class="mt-3 grid grid-cols-1 gap-2">
                <p-button label="Acta 360" icon="pi pi-download" severity="secondary" [outlined]="true" size="small" styleClass="w-full min-h-[44px]" [disabled]="!item.cdacta8 || descargandoDocumento()" (onClick)="descargarActa360(item)"></p-button>
                <p-button label="Observaciones" icon="pi pi-eye" severity="secondary" [outlined]="true" size="small" styleClass="w-full min-h-[44px]" [disabled]="!item.dsobs && !item.dsre" (onClick)="abrirObservacionesRecomendaciones(item)"></p-button>
                <p-button label="Doc. Capacitación" icon="pi pi-download" severity="secondary" [outlined]="true" size="small" styleClass="w-full min-h-[44px]" [disabled]="!item.cddocp8 || descargandoDocumento()" (onClick)="descargarDocumentoCapacitacion(item)"></p-button>
              </div>
            </div>
          }
        </div>

        <div class="hidden md:block">
        <p-table
          [resizableColumns]="true"
          columnResizeMode="expand"
          [value]="items()"
          [loading]="loading()"
          responsiveLayout="scroll"
          styleClass="tabla-informacion-empresa p-datatable-sm p-datatable-striped p-datatable-gridlines" [scrollable]="true" [tableStyle]="{ 'min-width': '72rem' }">
          <ng-template pTemplate="header">
            <tr>
              <th pResizableColumn><span class="grid-header-text" title="Orientación">Orientación</span></th>
              <th pResizableColumn><span class="grid-header-text" title="Tarea">Tarea</span></th>
              <th pResizableColumn><span class="grid-header-text" title="Clasificación">Clasificación</span></th>
              <th pResizableColumn><span class="grid-header-text" title="Tipo de Cita">Tipo de Cita</span></th>
              <th pResizableColumn><span class="grid-header-text" title="Horas Ejecutadas">Horas Ejecutadas</span></th>
              <th pResizableColumn><span class="grid-header-text" title="Asesor">Asesor</span></th>
              <th pResizableColumn><span class="grid-header-text" title="Tipo Asesor">Tipo Asesor</span></th>
              <th pResizableColumn><span class="grid-header-text" title="Oficina">Oficina</span></th>
              <th pResizableColumn><span class="grid-header-text" title="Empresa">Empresa</span></th>
              <th pResizableColumn><span class="grid-header-text" title="Centro Trabajo">Centro Trabajo</span></th>
              <th pResizableColumn><span class="grid-header-text" title="Fecha y Hora Cita">Fecha y Hora Cita</span></th>
              <th pResizableColumn class="text-center">Acta 360</th>
              <th pResizableColumn class="text-center">Observaciones y Recomendaciones</th>
              <th pResizableColumn class="text-center">Doc. Capacitación</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-item>
            <tr>
              <td><span class="grid-cell-text" [attr.title]="item.dsorden || '-'">{{ item.dsorden || '-' }}</span></td>
              <td><span class="grid-cell-text" [attr.title]="item.dstarea || '-'">{{ item.dstarea || '-' }}</span></td>
              <td><span class="grid-cell-text" [attr.title]="item.dsclasificacion || '-'">{{ item.dsclasificacion || '-' }}</span></td>
              <td><span class="grid-cell-text" [attr.title]="item.dstipocita || '-'">{{ item.dstipocita || '-' }}</span></td>
              <td>{{ item.nmcantidadEjecutada ?? '-' }}</td>
              <td><span class="grid-cell-text" [attr.title]="item.dsasesor || '-'">{{ item.dsasesor || '-' }}</span></td>
              <td><span class="grid-cell-text" [attr.title]="item.dstipo || '-'">{{ item.dstipo || '-' }}</span></td>
              <td><span class="grid-cell-text" [attr.title]="item.dsoficina || '-'">{{ item.dsoficina || '-' }}</span></td>
              <td><span class="grid-cell-text" [attr.title]="item.nomempresa || '-'">{{ item.nomempresa || '-' }}</span></td>
              <td><span class="grid-cell-text" [attr.title]="item.dscentrot || '-'">{{ item.dscentrot || '-' }}</span></td>
              <td>{{ item.feprogramacion || '-' }}</td>
              <td class="text-center">
                <button
                  pButton
                  icon="pi pi-download"
                  class="p-button-text p-button-sm min-w-[44px] min-h-[44px]"
                  pTooltip="Descargar Acta 360"
                  [disabled]="!item.cdacta8 || descargandoDocumento()"
                  (click)="descargarActa360(item)">
                </button>
              </td>
              <td class="text-center">
                <button
                  pButton
                  icon="pi pi-eye"
                  class="p-button-text p-button-sm min-w-[44px] min-h-[44px]"
                  pTooltip="Ver observaciones y recomendaciones"
                  [disabled]="!item.dsobs && !item.dsre"
                  (click)="abrirObservacionesRecomendaciones(item)">
                </button>
              </td>
              <td class="text-center">
                <button
                  pButton
                  icon="pi pi-download"
                  class="p-button-text p-button-sm min-w-[44px] min-h-[44px]"
                  pTooltip="Descargar documento de capacitación"
                  [disabled]="!item.cddocp8 || descargandoDocumento()"
                  (click)="descargarDocumentoCapacitacion(item)">
                </button>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="14" class="text-center p-6 text-gray-500">
                No se encontraron resultados para los filtros enviados.
              </td>
            </tr>
          </ng-template>
        </p-table>
        </div>
      </div>

      <div class="mt-4 flex justify-end">
        <p-paginator
          [rows]="rows()"
          [first]="first()"
          [totalRecords]="totalRecords()"
          [rowsPerPageOptions]="[10, 20, 50]"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
          dropdownAppendTo="body"
          appendTo="body"
          (onPageChange)="onPageChange($event)">
        </p-paginator>
      </div>

      <p-dialog
        [(visible)]="mostrarDialogoObsRe"
        [header]="'Observaciones y Recomendaciones'"
        [modal]="true"
        [style]="{ width: '95vw', maxWidth: '72rem' }"
        [breakpoints]="{ '960px': '96vw', '640px': '100vw' }">
        <div class="grid grid-cols-1 gap-3">
          <div>
            <label class="block text-sm text-gray-600 dark:text-gray-300 mb-1">Observaciones</label>
            <textarea pInputTextarea [value]="observacionesSeleccionadas()" rows="6" class="w-full" readonly></textarea>
          </div>
          <div>
            <label class="block text-sm text-gray-600 dark:text-gray-300 mb-1">Recomendaciones</label>
            <textarea pInputTextarea [value]="recomendacionesSeleccionadas()" rows="6" class="w-full" readonly></textarea>
          </div>
        </div>
        <ng-template pTemplate="footer">
          <div class="flex flex-wrap justify-end sm:justify-start gap-3 w-full">
            <button pButton label="Cerrar" class="p-button-outlined" (click)="mostrarDialogoObsRe = false"></button>
          </div>
        </ng-template>
      </p-dialog>

      @if (mostrarBuscadorTarea) {
        <app-busqueda-tarea-dialog
          [titulo]="'Búsqueda de Tarea'"
          (onSelect)="onTareaSeleccionada($event)"
          (onClose)="mostrarBuscadorTarea = false">
        </app-busqueda-tarea-dialog>
      }

      @if (mostrarBuscadorClasificacion) {
        <app-busqueda-clasificacion-dialog
          (onSelect)="onClasificacionSeleccionada($event)"
          (onClose)="mostrarBuscadorClasificacion = false">
        </app-busqueda-clasificacion-dialog>
      }

      @if (mostrarBuscadorCentroTrabajo) {
        <app-busqueda-centro-trabajo-dialog
          [titulo]="'Búsqueda de Centro de Trabajo'"
          [nmconsecutivoBeneficiario]="idBeneficiario()"
          [nombreBeneficiario]="nombreCliente()"
          [cargarAlAbrir]="true"
          (onSelect)="onCentroTrabajoSeleccionado($event)"
          (onClose)="mostrarBuscadorCentroTrabajo = false">
        </app-busqueda-centro-trabajo-dialog>
      }

      @if (mostrarBuscadorConsultor) {
        <app-asesor-search
          (onSelect)="seleccionarConsultor($event)"
          (onClose)="cerrarBusquedaConsultor()" />
      }
    </div>
  `
})
export class InformacionEmpresaDetalleServiciosEntregadosComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly informacionEmpresaRepository = inject(InformacionEmpresaRepository);
  private readonly oficinaRepository = inject(OficinaRepository);
  private readonly usuarioState = inject(UsuarioStateService);
  private readonly documentoP8Service = inject(DocumentoP8Service);
  private readonly messageService = inject(MessageService);

  readonly items = signal<InformacionEmpresaEjecDetalle[]>([]);
  readonly loading = signal(false);
  readonly totalRecords = signal(0);
  readonly first = signal(0);
  readonly rows = signal(10);
  readonly oficinas = signal<OpcionOficina[]>([]);
  readonly tiposCita = signal<OpcionCatalogo[]>([]);
  readonly estadosCita = signal<OpcionCatalogo[]>([]);
  readonly mensaje = signal('');
  readonly mensajeTipo = signal<'info' | 'warning' | 'error'>('info');
  readonly descargandoDocumento = signal(false);
  readonly mensajeDescarga = signal('Descargando archivo...');

  filtroOficina: number | null = null;
  filtroTipoCita: number | null = null;
  filtroEstadoCita: number | null = null;
  filtroCumplimiento = '';
  fechaInicial: Date | null = null;
  fechaFinal: Date | null = null;
  private oficinaSesion: number | null = null;

  mostrarBuscadorTarea = false;
  readonly tareaSeleccionada = signal<TareaSeleccionada | null>(null);

  mostrarBuscadorClasificacion = false;
  readonly clasificacionSeleccionada = signal<ClasificacionSeleccionada | null>(null);

  mostrarBuscadorCentroTrabajo = false;
  readonly centroTrabajoSeleccionado = signal<CentroTrabajoSeleccionado | null>(null);

  mostrarBuscadorConsultor = false;
  readonly consultorSeleccionado = signal<AsesorSeleccionado | null>(null);

  mostrarDialogoObsRe = false;
  readonly observacionesSeleccionadas = signal('');
  readonly recomendacionesSeleccionadas = signal('');

  ngOnInit(): void {
    void this.inicializar();
  }

  private async inicializar(): Promise<void> {
    await Promise.all([this.precargarSesionYOficinas(), this.cargarCatalogos()]);
    this.precargarCumplimientoDesdeContexto();
    this.precargarFechasPorAnio();
    await this.buscar();
  }

  readonly queryParamsRegreso = computed(() => {
    const query = { ...this.route.snapshot.queryParams } as Record<string, unknown>;
    delete query['cdproductoSeleccionado'];
    delete query['dsproductoSeleccionado'];
    delete query['cdoficinaSeleccionada'];
    delete query['dsoficinaSeleccionada'];
    return query;
  });

  readonly queryParamsPrincipal = computed(() => {
    const query = { ...this.route.snapshot.queryParams } as Record<string, unknown>;
    delete query['cdproductoSeleccionado'];
    delete query['dsproductoSeleccionado'];
    delete query['cdoficinaSeleccionada'];
    delete query['dsoficinaSeleccionada'];
    delete query['anioSeleccionado'];
    delete query['cumplimientoSeleccionado'];
    return query;
  });

  readonly nombreCliente = computed(
    () => this.route.snapshot.queryParamMap.get('nombreBeneficiario') ?? 'Sin cliente'
  );

  readonly nombreConsultor = computed(
    () => this.route.snapshot.queryParamMap.get('nombreConsultor') ?? 'Sin consultor'
  );

  readonly anio = computed(() => this.route.snapshot.queryParamMap.get('anioSeleccionado'));

  readonly cumplimiento = computed(
    () => this.route.snapshot.queryParamMap.get('cumplimientoSeleccionado')
  );

  readonly cdproducto = computed(
    () => this.route.snapshot.queryParamMap.get('cdproductoSeleccionado')
  );

  readonly dsproducto = computed(
    () => this.route.snapshot.queryParamMap.get('dsproductoSeleccionado')
  );

  readonly productoContexto = computed(() => {
    const codigo = this.cdproducto()?.trim();
    const descripcion = this.dsproducto()?.trim();
    if (codigo && descripcion) {
      return `${codigo} - ${descripcion}`;
    }
    return codigo || descripcion || '-';
  });

  readonly cdoficina = computed(
    () => this.route.snapshot.queryParamMap.get('cdoficinaSeleccionada')
  );

  readonly dsoficina = computed(
    () => this.route.snapshot.queryParamMap.get('dsoficinaSeleccionada')
  );

  readonly idBeneficiario = computed(() =>
    this.toNumber(this.route.snapshot.queryParamMap.get('nmconsecutivoBeneficiario'))
  );

  readonly idProducto = computed(() => this.toNumber(this.cdproducto()));

  readonly consultorSeleccionadoLabel = computed(() => {
    const consultor = this.consultorSeleccionado();
    if (!consultor) {
      return this.route.snapshot.queryParamMap.get('nombreConsultor') ?? '';
    }
    return [consultor.dsnombre1, consultor.dsnombre2, consultor.dsapellido1, consultor.dsapellido2]
      .filter(Boolean)
      .join(' ')
      .trim();
  });

  readonly tareaSeleccionadaLabel = computed(() => {
    const tarea = this.tareaSeleccionada();
    return tarea ? `${tarea.cdservicio} - ${tarea.dsservicio}` : '';
  });

  readonly clasificacionSeleccionadaLabel = computed(() => {
    const clasificacion = this.clasificacionSeleccionada();
    return clasificacion ? `${clasificacion.cdclasificacion} - ${clasificacion.dsclasificacion}` : '';
  });

  readonly centroTrabajoSeleccionadoLabel = computed(() => {
    const centro = this.centroTrabajoSeleccionado();
    return centro ? centro.descripcionCompleta : '';
  });

  readonly mensajeClass = computed(() => {
    if (this.mensajeTipo() === 'error') {
      return 'bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-200';
    }
    if (this.mensajeTipo() === 'warning') {
      return 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-200';
    }
    return 'bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-200';
  });

  async buscar(): Promise<void> {
    if (!this.validarFiltros()) {
      return;
    }
    this.first.set(0);
    await this.consultar(0, this.rows());
  }

  async onPageChange(event: PaginatorState): Promise<void> {
    const first = event.first ?? this.first();
    const rows = event.rows ?? this.rows();
    this.first.set(first);
    this.rows.set(rows);

    if (!this.validarFiltros(false)) {
      return;
    }

    await this.consultar(first, rows);
  }

  onTareaSeleccionada(tarea: TareaSeleccionada): void {
    this.tareaSeleccionada.set(tarea);
    this.mostrarBuscadorTarea = false;
  }

  onClasificacionSeleccionada(clasificacion: ClasificacionSeleccionada): void {
    this.clasificacionSeleccionada.set(clasificacion);
    this.mostrarBuscadorClasificacion = false;
  }

  limpiarTarea(): void {
    this.tareaSeleccionada.set(null);
  }

  limpiarClasificacion(): void {
    this.clasificacionSeleccionada.set(null);
  }

  abrirBusquedaCentroTrabajo(): void {
    if (!this.idBeneficiario()) {
      this.mensajeTipo.set('warning');
      this.mensaje.set('Debes seleccionar un cliente para buscar centro de trabajo.');
      return;
    }
    this.mostrarBuscadorCentroTrabajo = true;
  }

  onCentroTrabajoSeleccionado(centro: CentroTrabajoSeleccionado): void {
    this.centroTrabajoSeleccionado.set(centro);
    this.mostrarBuscadorCentroTrabajo = false;
  }

  limpiarCentroTrabajo(): void {
    this.centroTrabajoSeleccionado.set(null);
  }

  seleccionarConsultor(consultor: AsesorSeleccionado): void {
    this.consultorSeleccionado.set(consultor);
    this.mostrarBuscadorConsultor = false;
  }

  cerrarBusquedaConsultor(): void {
    this.mostrarBuscadorConsultor = false;
  }

  limpiarConsultor(): void {
    this.consultorSeleccionado.set(null);
  }

  onCumplimientoInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const valorNumerico = input.value.replace(/\D/g, '').slice(0, 11);
    this.filtroCumplimiento = valorNumerico;
    input.value = valorNumerico;
  }

  limpiarFiltros(): void {
    this.tareaSeleccionada.set(null);
    this.clasificacionSeleccionada.set(null);
    this.filtroTipoCita = null;
    this.filtroEstadoCita = null;
    this.precargarCumplimientoDesdeContexto();
    this.centroTrabajoSeleccionado.set(null);
    this.consultorSeleccionado.set(null);
    this.filtroOficina = this.oficinaSesion;
    this.precargarFechasPorAnio();
    this.items.set([]);
    this.totalRecords.set(0);
    this.first.set(0);
    this.mensaje.set('');
  }

  async descargarActa360(item: InformacionEmpresaEjecDetalle): Promise<void> {
    if (!item.cdacta8) {
      this.mostrarMensaje('warn', 'Sin acta', 'El registro no tiene acta 360 asociada.');
      return;
    }

    this.mensajeDescarga.set('Descargando acta...');
    this.descargandoDocumento.set(true);

    try {
      await this.documentoP8Service.descargar(item.cdacta8, `acta_${item.dsorden ?? item.nmradicado ?? 'servicio'}.pdf`);
      this.mostrarMensaje('success', 'Descarga iniciada', 'El acta 360 se está descargando.');
    } catch (error) {
      const mensaje = error instanceof Error ? error.message : 'No fue posible descargar el acta 360.';
      this.mostrarMensaje('error', 'Error al descargar', mensaje);
    } finally {
      this.descargandoDocumento.set(false);
    }
  }

  async descargarDocumentoCapacitacion(item: InformacionEmpresaEjecDetalle): Promise<void> {
    if (!item.cddocp8) {
      this.mostrarMensaje('warn', 'Sin documento', 'El registro no tiene documento de capacitación asociado.');
      return;
    }

    this.mensajeDescarga.set('Descargando documento de capacitación...');
    this.descargandoDocumento.set(true);

    try {
      await this.documentoP8Service.descargar(item.cddocp8, `capacitacion_${item.dsorden ?? item.nmradicado ?? 'servicio'}.pdf`);
      this.mostrarMensaje('success', 'Descarga iniciada', 'El documento de capacitación se está descargando.');
    } catch (error) {
      const mensaje = error instanceof Error ? error.message : 'No fue posible descargar el documento de capacitación.';
      this.mostrarMensaje('error', 'Error al descargar', mensaje);
    } finally {
      this.descargandoDocumento.set(false);
    }
  }

  abrirObservacionesRecomendaciones(item: InformacionEmpresaEjecDetalle): void {
    this.observacionesSeleccionadas.set(item.dsobs || 'Sin observaciones.');
    this.recomendacionesSeleccionadas.set(item.dsre || 'Sin recomendaciones.');
    this.mostrarDialogoObsRe = true;
  }

  private async precargarSesionYOficinas(): Promise<void> {
    const [usuario, oficinasData] = await Promise.all([
      this.usuarioState.cargar(),
      this.oficinaRepository.obtenerOficinas()
    ]);

    this.oficinas.set(
      oficinasData.map((oficina) => ({
        value: oficina.nmconsecutivo,
        label: oficina.dsoficina
      }))
    );

    const oficinaUsuario = usuario?.nmconsecOficina ?? null;
    const oficinaContexto = this.toNumber(this.cdoficina());
    this.oficinaSesion = oficinaUsuario;
    this.filtroOficina = oficinaContexto ?? oficinaUsuario;
  }

  private async cargarCatalogos(): Promise<void> {
    const tiposCita = await this.informacionEmpresaRepository.listarTiposCitaServicio();

    this.tiposCita.set(
      tiposCita
        .map((item) => ({
          label: item.descripcion,
          value: Number(item.codigo)
        }))
        .filter((item) => Number.isFinite(item.value))
    );

    this.estadosCita.set([
      { label: 'TODOS', value: null },
      { label: 'EJECUTADO', value: 1 },
      { label: 'FACTURADO', value: 2 }
    ]);
  }

  private precargarFechasPorAnio(): void {
    const anio = this.toNumber(this.anio());
    if (!anio) {
      this.fechaInicial = null;
      this.fechaFinal = null;
      return;
    }
    this.fechaInicial = new Date(anio, 0, 1);
    this.fechaFinal = new Date(anio, 11, 31);
  }

  private precargarCumplimientoDesdeContexto(): void {
    this.filtroCumplimiento = (this.cumplimiento() ?? '').replace(/\D/g, '').slice(0, 11);
  }

  private validarFiltros(mostrarError = true): boolean {
    if (!this.filtroOficina || !this.fechaInicial || !this.fechaFinal) {
      if (mostrarError) {
        this.mensajeTipo.set('warning');
        this.mensaje.set('Oficina, fecha inicial y fecha final son obligatorias.');
      }
      return false;
    }

    return true;
  }

  private async consultar(first: number, rows: number): Promise<void> {
    this.loading.set(true);
    this.mensaje.set('');

    try {
      const filtro: InformacionEmpresaEjecDetalleFiltro = {
        inutarea: this.tareaSeleccionada()?.nmconsecutivo,
        inuclasificacion: this.clasificacionSeleccionada()?.cdclasificacion,
        inutipocita: this.filtroTipoCita ?? undefined,
        inuestado_cita: this.filtroEstadoCita ?? undefined,
        inuasesor:
          this.consultorSeleccionado()?.cdpersona
          ?? this.toNumber(this.route.snapshot.queryParamMap.get('nmconsecutivoConsultor'))
          ?? undefined,
        inuoficina: this.filtroOficina ?? undefined,
        inucentrotrabajo: this.centroTrabajoSeleccionado()?.nmconsecutivo,
        inubeneficiario: this.idBeneficiario() ?? undefined,
        inuproducto: this.idProducto() ?? undefined,
        idafeini: this.formatDate(this.fechaInicial),
        idafefin: this.formatDate(this.fechaFinal),
        inuCumplimiento: this.filtroCumplimiento ? Number(this.filtroCumplimiento) : undefined,
        inudesde: first + 1,
        inuhasta: first + rows
      };

      const resultado = await this.informacionEmpresaRepository.listarDetalleServiciosEntregados(filtro);
      this.items.set(resultado);
      this.totalRecords.set(resultado[0]?.totalregistro ?? 0);
      if (resultado.length === 0) {
        this.mensajeTipo.set('info');
        this.mensaje.set('La consulta no retornó registros.');
      }
    } catch {
      this.items.set([]);
      this.totalRecords.set(0);
      this.mensajeTipo.set('error');
      this.mensaje.set('Error consultando detalle de servicios entregados.');
    } finally {
      this.loading.set(false);
    }
  }

  private mostrarMensaje(severity: 'success' | 'info' | 'warn' | 'error', summary: string, detail: string): void {
    this.messageService.add({ severity, summary, detail });
  }

  private formatDate(value: Date | null): string | undefined {
    if (!value) {
      return undefined;
    }
    const year = value.getFullYear();
    const month = `${value.getMonth() + 1}`.padStart(2, '0');
    const day = `${value.getDate()}`.padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  private toNumber(value: string | null): number | null {
    if (!value) {
      return null;
    }
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
}
